import script from "./ScriptDinamicSelectWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScriptDinamicSelectWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./ScriptDinamicSelectWrapper.vue?vue&type=style&index=0&id=65db4d8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65db4d8c"]])

export default __exports__